var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20152",
    "data-name": "\\uADF8\\uB8F9 20152",
    transform: "translate(-602 -362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10267",
    "data-name": "\\uD328\\uC2A4 10267",
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    transform: "translate(602 362)",
    fill: "#ffd0b8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_19294",
    "data-name": "\\uADF8\\uB8F9 19294",
    transform: "translate(307 -1075)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_25002",
    "data-name": "\\uC0AC\\uAC01\\uD615 25002",
    width: 16,
    height: 16,
    transform: "translate(299 1442)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_15423",
    "data-name": "\\uADF8\\uB8F9 15423",
    transform: "translate(303 1447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-check",
    "data-name": "Icon feather-check",
    d: "M13.326,9,8.289,14.546,6,12.025",
    transform: "translate(-6 -9)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDone);
export default __webpack_public_path__ + "static/media/CheckDone.76fb3f29c148918c028ceb0667155d6e.svg";
export { ForwardRef as ReactComponent };